import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=09c6ff24&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormTextarea, BFormCheckbox, BButton, BCard, BForm} from 'bootstrap-vue'
    installComponents(component, {BFormTextarea, BFormCheckbox, BButton, BCard, BForm})
    

export default component.exports